
import { React, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import ScrollToTop from './utils/ScrollToTop';


import { WOW } from 'wowjs';
import 'wowjs/css/libs/animate.css';

import { Header } from './components/Header/Header';
import { Footer } from './components/Footer/Footer';

import { Home } from './pages/Home';
import { Application } from './pages/Application';
import { Contacts } from './pages/Contacts';
import { Faq } from './pages/Faq';
import { Registration } from './pages/Registration';


import { menuInit, headerScroll, langInit, initDynamicAdapt } from './utils/Functions';
let step = 0;
function App() {
	useEffect(()=>{
		if(step++ ===0) {
			menuInit();
			// langInit();
			headerScroll();
			initDynamicAdapt();


			const wow = new WOW({
				mobile: false
			})
			wow.init();
		}





	}, [])



	return (
		<div className="wrapper">
			<meta property="og:type" content="website" />
			<meta property="og:site_name" content="MOSTBET Agent" />
			<meta name="format-detection" content="telephone=no" />
			<meta property="og:image" content="/favicon.png" />

			<Router>
				<ScrollToTop />
				<Header />
				<Routes>
					<Route path='/' element={<Home />} />
					<Route path='/registration' element={<Registration />} />
					<Route path='/app' element={<Application />} />
					<Route path='/faq' element={<Faq />} />
					<Route path='/contacts' element={<Contacts />} />
				</Routes>
				<Footer />
			</Router>
		</div>
	);
}

export default App;
